<div class="wccard pt-2" style="height: 100vh;" id="topActivity">
  <div class="col wccard">
    <div *ngFor="let group of groupedActivityList" class="activity-group">
      <div class="activity-date">{{ group.displayDate }}</div>
      <div *ngFor="let item of group.items" class="activity-entry">
        <div class="activity-icon">{{item.firstname?.charAt(0)?.toUpperCase()}}</div>

        <div class="activity-details">
          <span class="activity-name">{{ item.firstname }} {{ item.lastname }}</span>
          <span class="activity-action">{{ item.action }}</span>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- <app-blurbackdrop *ngIf="projectDetails?.status == 'inactive'"></app-blurbackdrop> -->
